import { ComponentProps } from 'react';
import clsx from 'clsx';
import Avatar from 'antd/es/avatar/Avatar';

interface OpAvatarProps
  extends Omit<ComponentProps<typeof Avatar>, 'data-testid'> {
  testId?: string;
}

/**
 * OpAvatar is a wrapper around Ant Design's Avatar component.
 * It displays user profile pictures, icons, or text in a circular or square container.
 * 
 * Use this component to represent users or entities throughout the application with consistent avatar styling.
 * 
 * @example
 * <OpAvatar src="/path/to/image.jpg" />
 * <OpAvatar icon={<UserOutlined />} />
 * <OpAvatar>JD</OpAvatar>
 * 
 */
export const OpAvatar = ({
  testId = 'op-avatar',
  className,
  ...alertProps
}: OpAvatarProps) => {
  return (
    <Avatar
      {...alertProps}
      className={clsx('op-avatar', className)}
      data-testid={testId}
    />
  );
};
